import { useState, useEffect, useRef } from 'react';
import { searchProperties, getProperty } from '../api/client.js';

export function useProperties(filters) {
  const [data, setData]     = useState([]);
  const [total, setTotal]   = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);
  const abortRef = useRef(null);

  useEffect(() => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    searchProperties(filters, ctrl.signal)
      .then(res => { if (!ctrl.signal.aborted) { setData(res.objects); setTotal(res.meta.total_count); setLoading(false); } })
      .catch(err => { if (!ctrl.signal.aborted) { setError(err.message); setLoading(false); } });
    return () => ctrl.abort();
  }, [JSON.stringify(filters)]);

  return { data, total, loading, error };
}

export function useProperty(id) {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError(null);
    getProperty(id)
      .then(p => { setData(p); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, [id]);

  return { data, loading, error };
}
